<footer>
  <p>©2021 - オンライン服薬指導システム</p>
</footer>